export default "__VITE_ASSET__DC7QfvaC__"